import React, { useContext } from 'react';
import { Link } from 'anf-core-react';
import ProductPageContext from '../../contexts/ProductPageContext';
import { removeStoredQuickview } from '../StoreQuickviewProvider/StoreQuickviewProvider';

function LinkToFullPDP({
  children,
}) {
  const ProductPageState = useContext(ProductPageContext);

  const {
    collectionData,
    pageViewMethod,
    productViewMethod,
    dataText,
    dataAction,
  } = ProductPageState || {};
  const { activeProduct } = collectionData || {};
  const { productPageUrl, brand } = activeProduct || {};

  const buildViewFullDetailsUrl = () => {
    if (!productPageUrl) return window.location.origin;

    const url = new URL(window.location.origin + productPageUrl);

    if (pageViewMethod) {
      url.searchParams.append('pageViewMethod', pageViewMethod);
    }
    if (productViewMethod) {
      url.searchParams.append('pageFindingMethod', productViewMethod);
    }
    if (dataText) {
      url.searchParams.append('dataText', dataText);
    }
    if (dataAction) {
      url.searchParams.append('dataAction', dataAction);
    }

    return url.toString();
  };

  return (
    <Link
      brand={brand === 'gh' ? 'hol' : activeProduct?.brand}
      href={buildViewFullDetailsUrl()}
      onClick={removeStoredQuickview}
    >
      {children}
    </Link>
  );
}

export default LinkToFullPDP;
